<template>
  <ul class="labelLegend" :class="{ open: open }">
    <template v-for="item in legendList" :key="item.name">
      <li
        :style="{ color: item.radio == radioValue ? '#fff' : '#fff' }"
        class="labelLegendItem"
        @click.prevent="labelLegendClick(item)"
      >
        <el-radio
          v-model="radioValue"
          size="small"
          :label="item.radio"
          :disabled="disableRadio"
        >
          {{ "" }}</el-radio
        >
        <!-- <i class="legend" :style="{ backgroundColor: item.color }"></i> -->
        <span class="text">{{ `${item.name}  (${item.num})` }}</span>
      </li>
    </template>
    <template v-for="(item, index) in openlegendList" :key="index">
      <li
        :style="{ color: !item.checked ? '#fff' : '#fff' }"
        class="labelLegendItem"
        @click="switchClick(item, index)"
      >
        <!-- <i class="legend">
          <el-switch
            v-model="value"
            class="ml-2"
            size="small"
            active-color="#62cfdf"
            inactive-color="#a0a0a2"
          />
        </i> -->
        <div class="leftSwitch" :class="{ switchState: item.checked }">
          <div :class="['switchCir', { switchright: item.checked }]"></div>
        </div>
        <!-- switchFalse:'switchright'?'switchCir' -->
        <span class="text" v-if="item.name != '数据概览'">{{
          `${item.name}  (${item.num})`
        }}</span>
        <span class="text" v-else>{{ `${item.name} ` }}</span>
      </li>
    </template>
  </ul>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,

  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import { createContext, useContext } from "@/hooks/core/useContext.js";
export default defineComponent({
  name: "",
  components: {},
  props: {
    open: {
      type: Boolean,
      default: true,
    },
    workmanshipPoint: {
      type: Array,
    },
    companyPoint: {
      type: Array,
    },
    cameraList: {
      type: Array,
    },
    deviceList: {
      type: Array,
    },
    cameraPointRef: {
      type: Array,
    },
    numCount: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const data = reactive({
      value: "",
      legendList: [
        // {
        //   radio: "1",
        //   name: "重点人员",
        //   color: "#fe4a3c",
        //   num: 0,
        //   type: 1,
        // },
        {
          radio: "2",
          name: "安防设施",
          color: "#fe913f",
          num: 0,
          type: 2,
        }, // #fe913f
        {
          radio: "3",
          name: "实有房屋",
          color: "#fdfa40",
          num: 0,
          type: 3,
        }, // fdfa40
        {
          radio: "4",
          name: "实有单位",
          color: "#005cd7",
          num: 0,
          type: 4,
        }, // #43d4fe
        // 5: { checked: true, type: 5, name: '非重大', color: '#A0A0A2', num: 0, radio: '4' }
      ],
      radioValue: "2",
      openlegendList: [
        // {
        //   checked: false,
        //   type: 1,
        //   name: "一标三实",
        //   color: "#fe4a3c",
        //   num: 0,
        // },
        {
          checked: false,
          type: 2,
          name: "监控设备",
          color: "#fe913f",
          num: 0,
        }, // #fe913f
        {
          checked: true,
          type: 3,
          name: "数据概览",
          color: "#fdfa40",
          num: 0,
        },
        // fdfa40
        // 4: { checked: true, type: 4, name: '实有房屋', color: '#005cd7', num: 0 } // #43d4fe
      ],
      disableRadio: false,
    });
    const refData = toRefs(data);
    watchEffect(() => {
      data.legendList[0].num = props.numCount.security;
      data.legendList[1].num = props.numCount.house;
      data.legendList[2].num = props.numCount.unit;
      data.openlegendList[0].num = props.numCount.video;
    });
    const switchClick = (item, ind) => {
      data.openlegendList.forEach((element) => {
        element.checked = !element.checked;
      });
      if (data.openlegendList[0].checked) {
        data.radioValue = "";
      } else {
        data.radioValue = "2";
      }
      emit("getSwitchState", data.openlegendList);
    };
    const labelLegendClick = (item, ind) => {
      data.legendList.forEach((element) => {
        if (element.name == item.name) {
          data.radioValue = item.radio;
        }
      });
      if (data.openlegendList[0].checked) {
        data.openlegendList[0].checked = false;
        data.openlegendList[1].checked = true;
        emit("getSwitchState", data.openlegendList);
      }
      emit("getlabelLegend", item);
    };
    emit("getSwitchState", data.openlegendList);
    return {
      ...refData,
      switchClick,
      labelLegendClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.labelLegend {
  width: 173px;
  height: 205px;
  position: absolute;
  bottom: 170px;
  right: 15px;
  z-index: 1;
  color: #fff;
  padding: 5px 10px 15px;
  transition: all 0.5s;
  @include flex-col-se-s;
  background: rgba(98, 98, 98, 0.5);
  border-radius: 4px;
  .labelLegendItem {
    cursor: pointer;
    display: flex;
    align-items: center;
    .leftSwitch {
      width: 20px;
      height: 10px;
      background: rgb(63, 58, 58);
      border-radius: 10px;
      position: relative;
      margin-right: 15px;
      .switchCir {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        background: #fff;
        position: absolute;
        // left: 0;
      }
      .switchright {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        background: #fff;
        position: absolute;
        right: 0;
      }
    }
    .switchState {
      background: #62cfdf;
      pointer-events: none;
    }
  }
  &.open {
    right: 425px;
  }
  .legend {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 10px;
    font-size: 14px;
    :deep(.el-switch__core) {
      width: 25px !important;
      height: 10px !important;
    }
    :deep(.el-switch__action) {
      width: 12px !important;
      height: 12px !important;
    }
  }
  :deep(.el-radio) {
    margin-right: 12px !important;
  }
}
</style>
